import React, { FC, useEffect, useState } from 'react';
import FormAdmin from './components/FormAdmin';
import { getSecuritySection, SecurityModel, SecuritySections } from '../../../models/security/security';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { useHistory } from 'react-router';
import { FallbackPage } from '../../../components/layout/navbar/Navbar';

const CreateFormPage: FC = () => {
  const [formSecurity, setFormSecurity] = useState<SecurityModel | null>(null);
  const security = useSelector((state: RootState) => state.organization.organization?.security);
  const history = useHistory();

  useEffect(() => {
    if (security) {
      setFormSecurity(getSecuritySection(security, SecuritySections.FORM));
    }
    if (formSecurity && !formSecurity?.write) {
      history.push(FallbackPage);
    }
  }, [security, formSecurity]);
  return <FormAdmin />;
};

export default CreateFormPage;
